import Swal from "sweetalert2";

// Flag to prevent multiple 401 modals from showing
let isRedirecting = false;

export default function setupAxios(axios: any, store: any) {
  axios.defaults.headers.Accept = "application/json";

  // Request interceptor
  axios.interceptors.request.use(
    (config: any) => {
      const {
        auth: { accessToken },
      } = store.getState();

      if (accessToken) {
        config.headers.Authorization = `Bearer ${accessToken}`;
      }

      return config;
    },
    (err: any) => Promise.reject(err),
  );

  // Response interceptor for handling 401 errors globally
  axios.interceptors.response.use(
    (response: any) => response,
    async (error: any) => {
      if (error?.response?.status === 401 && !isRedirecting) {
        isRedirecting = true;

        // Show warning modal
        await Swal.fire({
          position: "center",
          icon: "warning",
          title: "Session Expired",
          text:
            error?.response?.data?.message ||
            "Your session has expired. Please login again.",
          showConfirmButton: true,
          confirmButtonText: "Login Again",
          allowOutsideClick: false,
        });

        // Logout and clear storage
        localStorage.removeItem("token");
        localStorage.removeItem("persist:v100-admin-auth");

        // Redirect to login page
        window.location.href = "/auth/login";
      }

      return Promise.reject(error);
    },
  );
}
